import { render, staticRenderFns } from "./editPackResourceModal.vue?vue&type=template&id=4de088d3&scoped=true"
import script from "./editPackResourceModal.vue?vue&type=script&lang=js"
export * from "./editPackResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de088d3",
  null
  
)

export default component.exports